import StoryPictureElement from './StoryPictureElement'
import StoryVideoElement from './StoryVideoElement'
import type { StoryMedia } from './storyMedia'

export interface StoryMediaElementProps {
	media: StoryMedia
	onTogglePlayback?: () => void
	onToggleMuted?: () => void
	onPlaybackBlocked?: () => void
	onPlaybackTimeChange?: (currentTime: number) => void
	onRetry?: () => Promise<void>
	onLoadingChange?: (loading: boolean) => void
}

export default function StoryMediaElement({
	media,
	onTogglePlayback,
	onToggleMuted,
	onPlaybackBlocked,
	onPlaybackTimeChange,
	onRetry,
	onLoadingChange,
}: StoryMediaElementProps) {
	if (media.type === 'PICTURE') {
		return <StoryPictureElement media={media} onLoadingChange={onLoadingChange} />
	}

	return (
		<StoryVideoElement
			media={media}
			onTogglePlayback={onTogglePlayback}
			onToggleMuted={onToggleMuted}
			onPlaybackBlocked={onPlaybackBlocked}
			onPlaybackTimeChange={onPlaybackTimeChange}
			onRetry={onRetry}
			onLoadingChange={onLoadingChange}
		/>
	)
}
